import React, { useState, useRef, useEffect } from 'react';
import * as d3 from 'd3';
import '../styles/Charts.css';

const ChartPie = ({ dataProps }) => {
    // preset data if data props not given
    const [dataPie, updateDataPie] = useState([
        {property: 'user', value: 10},
        {property: 'admin', value: 19}
    ]) 
    
    const data = dataProps || dataPie;

    // Use useRef for the SVG element  
    const svgRef = useRef();

    // Attributes of the chart
    const width = 200;
    const height = 200;
    const radius = Math.min(width, height) / 2;

    useEffect(() => {
        // do not create the pie chart if no data
        if (!data || data.length === 0) return;

        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height)
            .append('g')
            .attr('transform', `translate(${width / 2}, ${height / 2})`);

        const colorCustom = ["#404040","#606060","#808080","#c0c0c0","#e0e0e0","#f0f0f0","#ffffff"]
        
        // Define color scale
        const color = d3.scaleOrdinal()
            .domain(data.map(d => d.property)) // get 'property' attribute from an item in the data set
            .range(colorCustom);

        /* preset colors */
        // d3.schemeCategory10    

        // Define pie function
        const pie = d3.pie().value(
            d => d.value // get 'value' attribute from an item in the data set
        )
        .padAngle(0.03); // spacing between arcs

        // Create arcs
        const arc = d3.arc()
            .innerRadius(0)
            .outerRadius(radius);

        // Generate each arc in the pie chart
        const arcs = svg.selectAll('path')
            .data(pie(data))
            .enter()
            .append('path')
            .attr('d', arc)
            .attr('fill', d => color(d.data.property))
            // .attr('stroke', 'black')
            // .attr('stroke-width', '2px')

        // Create legend labels above chart
        const labelsArea = d3.select('#labelsPie');
        labelsArea.selectAll('*').remove();   

        svg.selectAll('text')
            .data(pie(data))
            .enter()
            .append('text')
            .text((d)=>d.data.value)
            .attr('class', 'text-label')
            .attr('text-anchor', 'middle')
            .attr('font-size', 18) 
            .attr('transform', d => `translate(${arc.centroid(d)})`);

        // Create legend for data1 and data2
        const labelDivs = labelsArea.selectAll('div')
            .data(pie(data))
            .enter()
            .append('div')
            .attr('class', 'label-container');

        labelDivs.append('div')
            .attr('class', 'color-circle')
            .style('background-color', d => color(d.data.property));

        labelDivs.append('span')
            .text(d => `${d.data.property}`)
            .attr('class', 'text-legend')
            ;

        return () => {
            svg.selectAll('path').remove(); // Cleanup on unmount or data change
        };

    }, [data]); 

    return (
        <div>
            <article id='labelsPie'>
                {/* data legend will be here */}
            </article>
            <svg 
            ref={svgRef}
            width={width}
            height={height}
            >
            </svg>
        </div>
    );  
}

export default ChartPie;